import { render } from "./ChatSpoiler.vue?vue&type=template&id=f10f185c"
import script from "./ChatSpoiler.vue?vue&type=script&lang=js"
export * from "./ChatSpoiler.vue?vue&type=script&lang=js"

import "./ChatSpoiler.vue?vue&type=style&index=0&id=f10f185c&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__